import type { Partner } from "@stockline/shared/types/crm/partner"
import { PARTNER_TABLE } from "../../../lib/offline/resources/crm/partner/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

const NO_MATCH_ID = "00000000-0000-0000-0000-000000000000"

export function usePartner(id: string | null): Partner | null {
  const { reactive } = useAISync()
  // Always call the hook to satisfy Rules of Hooks; a sentinel UUID
  // produces an empty result when the caller passes null.
  return reactive.useOne<Partner>(PARTNER_TABLE, id ?? NO_MATCH_ID)
}
